import { Component, Shark, Utils } from "shark-mvc";
import moment from "moment";
import { Modal } from "bootstrap";

import WorkSession from "../../models/WorkSession";

import templateContent from "./work-session-details.html";

import messageModalComponent from "../messageModal/messageModalComponent";
import projectManager from "../../managers/projectManager";
import taskManager from "../../managers/taskManager";
import workSessionManager from "../../managers/workSessionManager";

class WorkSessionDetailsModalComponent extends Component {
	constructor () {
		super("workSessionDetailsModalComponent");

		this.addTemplate("", templateContent);
	}

	addManualSessionBtn_clickHandler (event, data) {
		const { currWorkSession } = Shark.get();

		// if (currWorkSession && Shark.get("taskList")) {
		// 	Shark.set({
		// 		wsDetailsTaskList: [...Shark.get("taskList")],
		// 	});
		// }

		const manualWorkSession = new WorkSession({
			endDate: moment(data?.date),
			startDate: moment(data?.date),
			userGuid: Shark.get("currUser").guid,
			status: 1, 

			clientGuid: currWorkSession ? currWorkSession.clientGuid : "",
			projectGuid: currWorkSession ? currWorkSession.projectGuid : "",
			taskGuid: currWorkSession ? currWorkSession.taskGuid : "",
		});

		Shark.set({
			manualWorkSession,
		});

		this.manualWorkSession_projectGuidChangedHandler();
		this.manualWorkSession_taskGuidChangedHandler();

		manualWorkSession.on("projectGuidChanged", this.manualWorkSession_projectGuidChangedHandler);
		manualWorkSession.on("taskGuidChanged", this.manualWorkSession_taskGuidChangedHandler);
		
		workSessionDetailsModalComponent.open(Shark.get("taskList"));
		this.toggleWorkSessionEditing();
	}

	afterLoad () {
		this.modal = new Modal(document.querySelector("#workSessionDetailModal"));
	}

	close () {
		this.set({
			open: false,
		});
		// $("#workSessionDetailModal").modal("hide");
		if (this.modal) {
			this.modal.hide();
		}
	}

	descriptionField_focusHandler (event) {
		const { manualWorkSession } = Shark.get();

		if (manualWorkSession && manualWorkSession.description === manualWorkSession.__defaultDescription) {
			event.target.select();
		}
	}

	editWorkSessionBtn_clickHandler (event, data) {
		const { fullWorkSessionList } = Shark.get();
		const currWorkSession = Utils.safp(fullWorkSessionList, "guid", data.guid);
		const filters = { projectGuid: currWorkSession.projectGuid };

		taskManager.getList2(filters, true)
		.then(getResponse => {
			const manualWorkSession = currWorkSession;
			manualWorkSession.__projectSelected = manualWorkSession.projectGuid != "";
			// manualWorkSession.__taskSelected = manualWorkSession.taskGuid != "",

			// console.log("picco");
			// console.log(currWorkSession.__projectSelected);

			Shark.set({
				manualWorkSession,
			});
			manualWorkSession.on("projectGuidChanged", this.manualWorkSession_projectGuidChangedHandler);
			manualWorkSession.on("taskGuidChanged", this.manualWorkSession_taskGuidChangedHandler);

			this.manualWorkSession_projectGuidChangedHandler();
			
			if (this.modal) {
				this.open(getResponse.data);
			}

			this.toggleWorkSessionEditingBtn_clickHandler();
		});

	}

	init () {
		this.addComponents([messageModalComponent]);

		this.set({
			open: false,
		});

		Shark.set({
			__isEditingWorkSession: false,
			_saveEditingWorkSessionBtnStatusCSSClasses: "btn-success",
		});
	}
	
	manualWorkSession_projectGuidChangedHandler () {
		const { manualWorkSession } = Shark.get();

		if (manualWorkSession.projectGuid) {
			const filters = { projectGuid: manualWorkSession.projectGuid };
			
			taskManager.getList2(filters, true)
			.then(getTaskListResponse => {
				// console.log(getTaskListResponse.data);
				//Dave: Se questo lo mettiamo su Shark si renderizza da solo (oppure auotrender anche su componenti e views)
				// document.querySelectorAll(`[data-sh-prop="projectGuid"]`).forEach(item =>  manualWorkSession.projectGuid == "" ? item.classList.add("invalid") : item.classList.remove("invalid")); 
				
				workSessionDetailsModalComponent.set({
					wsDetailsTaskList: getTaskListResponse.data,
					__projectHasTasks: getTaskListResponse.data?.length > 0,
					__projectSelected: manualWorkSession.projectGuid != "",
					// __taskSelected: false,
				});
				// Shark.render();
			});
		}
	}

	manualWorkSession_taskGuidChangedHandler () {
		const { manualWorkSession } = Shark.get();
		document.querySelectorAll(`[data-sh-prop="taskGuid"]`).forEach(item =>  manualWorkSession.taskGuid == "" ? item.classList.add("invalid") : item.classList.remove("invalid")); 
	
		// workSessionDetailsModalComponent.set({
		// 	__taskSelected: manualWorkSession.taskGuid != "",
		// });

		Shark.render();
	}

	async open (taskList) {
		const { projectFilters, /*projectList,*/ statsFilters } = Shark.get();

		//ALICE:  brutto da cambiaer e ottimizzare
		//if(!projectList) {
		const filtersToUse = projectFilters ? projectFilters : statsFilters;

		filtersToUse.statusList = filtersToUse.statusList || [1, 3];
		if (filtersToUse && filtersToUse.selectedOrganizationGuidList && filtersToUse.selectedOrganizationGuidList.length > 0) {
			Shark.set({
				__isLoadingProjects: true,
			});
			projectManager.getList(filtersToUse)
			.then(() => {
				Shark.set({
					__isLoadingProjects: false,
				});
			});
		}
		//}

		this.set({
			open: true,
			wsDetailsTaskList: taskList || [],
		});
		Shark.$store.__isEditingWorkSession = false;
		Shark.render();

		// $("#workSessionDetailModal").modal("show");
		if (this.modal) {
			this.modal.show();
		}
	}

	setTimeToNow (startOrEnd) {
		const { manualWorkSession } = Shark.get();

		if (manualWorkSession) {
			const now = moment();
			
			manualWorkSession.set({
				[`__${startOrEnd}Date`]: now.format("YYYY-MM-DD"),
				[`__${startOrEnd}Time`]: now.format("HH:mm:ss"),
			});
		}
	}

	setEndToNowBtn_clickHandler () {
		this.setTimeToNow("end");
	}

	setStartToNowBtn_clickHandler () {
		this.setTimeToNow("start");
	}

	toggleWorkSessionEditing () {
		const { manualWorkSession } = Shark.get();

		// console.log(manualWorkSession.projectGuid != "", manualWorkSession.taskGuid != "");
		workSessionDetailsModalComponent.set({
			__projectSelected: manualWorkSession.projectGuid != "",
			// __taskSelected: manualWorkSession.taskGuid != "",
		});
		
		// console.log({manualWorkSession});
		Shark.$store.__isEditingWorkSession = !Shark.$store.__isEditingWorkSession;
		manualWorkSession.updateScreenWithModelValues();
	}

	async toggleWorkSessionEditingBtn_clickHandler () {
		const { manualWorkSession } = Shark.get();

		// console.log({manualWorkSession});

		if (Shark.$store.__isEditingWorkSession && manualWorkSession.isDirty()) {
			const confirmResponse = await messageModalComponent.open(Shark.$store.labels.warning_changes_not_saved, {
				cancelButtonLabel: "Annulla le modifiche",
				okButtonLabel: "Continua a modificare",
				showCancelButton: true,
			});

			if (confirmResponse) {
				return;
			}

			if (manualWorkSession.guid === "") {
				this.close();
			}
			else {
				manualWorkSession.restore();
			}
		}

		if (manualWorkSession.guid === "") {
			this.close();
		}
		else {
			this.toggleWorkSessionEditing();
		}
	}

	workSessionDetailModalCancelBtn_clickHandler () {
		this.close();
	}

	// workSessionDetailModalTaskListField_changeHandler () {
	// 	const { manualWorkSession } = Shark.get();
	// 	document.querySelectorAll(`[data-sh-prop="taskGuid"]`).forEach(item =>  manualWorkSession.taskGuid == "" ? item.classList.add("invalid") : item.classList.remove("invalid")); 
	// 	Shark.render();
	// }

	// workSessionDetailModalProjectListField_changeHandler () {
	// 	const { manualWorkSession } = Shark.get();
	// 	const filters = {projectGuid: manualWorkSession.projectGuid};
		
	// 	taskManager.getList2(filters, true)
	// 	.then(getTaskListResponse => {
	// 		//Dave: Se questo lo mettiamo su Shark si renderizza da solo (oppure auotrender anche su componenti e views)
	// 		document.querySelectorAll(`[data-sh-prop="projectGuid"]`).forEach(item =>  manualWorkSession.projectGuid == "" ? item.classList.add("invalid") : item.classList.remove("invalid")); 
	// 		this.set({
	// 			wsDetailsTaskList: getTaskListResponse.data,
	// 			__projectSelected: manualWorkSession.projectGuid != "",
	// 		});
	// 		Shark.render();
	// 	});
	// }

	workSessionDetailModalSaveBtn_clickHandler () {
		const { manualWorkSession } = Shark.get();

		// if (manualWorkSession.guid === "") {
		// 	manualWorkSession.set({
		// 		projectGuid: currWorkSession.projectGuid,
		// 		taskGuid: currWorkSession.taskGuid,
		// 		userGuid: currWorkSession.userGuid,
		// 	});
		// }

		const errors = manualWorkSession.validate();
		if(errors.length == 0) {
			workSessionManager.save(manualWorkSession)
			.then(() => {
				this.close();
				workSessionManager.emit("singleWorkSessionUpdated");
			});
		}
		else {
			errors.forEach(error => {
				document.querySelectorAll(`[data-sh-prop="${error.field}"]`).forEach(item => item.classList.remove("invalid")); 
				setTimeout(function(){
					document.querySelectorAll(`[data-sh-prop="${error.field}"]`).forEach(item => item.classList.add("invalid")); 
				}, 250);
			});
		}
	}
}

const workSessionDetailsModalComponent = new WorkSessionDetailsModalComponent();

Shark.registerComponent(workSessionDetailsModalComponent);

export default workSessionDetailsModalComponent;